/**
 * Reset API
 *
 * @author minkyoung.park@emcast.com
*/
import httpService from '@/api/httpService'

const resetApi = {
    // 로그인(login)
    // https://clpapi.tinkeredu.co.kr/static/docs/account.html#resources-account-change-password
    resetPassword(params) {
        return httpService.put('/membership/member/password', params)
    },
}

export default resetApi